import { pageTypes } from './pageTypes'

export const mobileMediaQuery = '(max-width: 800px)'
export const desktopMediaQuery = '(min-width: 801px)'
export const inlineMobileMediaQuery = '(max-width: 480px)'
export const inlineDesktopMediaQuery = '(min-width: 481px)'

export const commonMediaQueries = {
  phone: `@media only screen and ${mobileMediaQuery}`,
  desktop: `@media only screen and ${desktopMediaQuery}`,
}

export const inlineMediaQueries = {
  phone: `@media only screen and ${inlineMobileMediaQuery}`,
  desktop: `@media only screen and ${inlineDesktopMediaQuery}`,
}

export function getMediaCondition(mediaQuery, fallback = mobileMediaQuery) {
  if (typeof mediaQuery !== 'string') {
    return fallback
  }

  const mediaCondition = mediaQuery.trim().replace(/^@media\s*/i, '')
  return mediaCondition || fallback
}

export function getMediaQueryByPageType(pageType) {
  switch (pageType) {
    case pageTypes.inline:
      return inlineMediaQueries
    default:
      return commonMediaQueries
  }
}
